/* eslint-disable */
import { useParameter, useExport } from "../../../shared";
import * as React from "react";
import { REPORT_ID } from "../constants";

const CALENDAR_STEP = 10000;

export function useExportQuery(title, subtitle) {
  const exportBuilder = useExport();
  const [commodity] = useParameter<number>("@commodities");
  const [countries] = useParameter<number[]>("@countries");
  const [calendar] = useParameter<number>("@calendar");
  const [businessUnit] = useParameter<number>("@business-units");
  const [commodityDisplay] = useParameter<number>("@commodities_display");
  const [countriesDisplay] = useParameter<number[]>("@countries_display");

  React.useEffect(() => {
    exportBuilder.set('title', title);
    exportBuilder.set('subtitle', subtitle);
    exportBuilder.set('reportDefinition', {
      reportId: exportBuilder.reportId,
      name: { 9: title },
      parameters: {
        "@commodities": String(commodity),
        "@commodities_display": String(commodityDisplay),
        "@countries": countries?.map(String),
        "@countries_display": countriesDisplay?.map(String),
        "@business-units": String(businessUnit),
        "@calendar":String(calendar),
        "@xlsx_calendar": [-5,-4,-3,-2,-1,0].map(x => String((calendar || 0) + (x * CALENDAR_STEP))),

      }
    });
  }, [title, subtitle, exportBuilder, calendar, countries, calendar, businessUnit, commodityDisplay, countriesDisplay]);
}

